import Head from 'next/head';
import React, { useState, useEffect, useDebugValue } from 'react';
import Image from 'next/image';

// Components for building the Page
// import Footer from '../../components/common/Footer';
import Footer from '../../components/common/footer';
import Header from '../../components/common/header';
import Placeholder from '../../components/common/placeholder';
import { Container, Row, Col } from 'react-bootstrap';
//i18n
import { useTranslation } from 'react-i18next';
//Markdown-Parser
import ReactMarkdown from 'react-markdown'
//Markdown Plugin - for tables etc.
import remarkGfm from 'remark-gfm'
// Custom NPM Package
import { BackToTopButton,CookieBanner,EmbeddedCookieBanner } from '@benchvondaranch/npm.react-ui-library';
import variables from '../../styles/variables.module.scss';
// Using Global Redux State
import { useSelector, useDispatch } from 'react-redux';
import { updateLocalStorage } from '../../store/userSlice';


function LinkRenderer(props) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
}


export default function DataProtection() {

  const { t, i18n } = useTranslation();
  const [dataProtectionData, setDataProtectionData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch()
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const getDataProtectionData = async () => {

      try {
        
        const response = await fetch(`/api/backend/legal/dataprotection?locale=${i18n.language}`, {
                headers: {
                  Accept: "application/json",
                },
          });
      
        const dataProtectionData = await response.json();      
        setDataProtectionData(dataProtectionData);
        
      } catch (error) {

        console.log('[Error - DataProtection] - ' + error);
        const dummyDataProtectionData ={};
        dummyDataProtectionData.description = t('error_message_no_data_loaded');
        setDataProtectionData(dummyDataProtectionData);
      }
      finally{
        setIsLoading(false)
      }
    };

   

  useEffect(() => {       
       async function fetchDataFromNextAPI() {                
          getDataProtectionData();                 
        }      
        fetchDataFromNextAPI();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[i18n.language])

  const localStorageRedux = useSelector((state) => state.user.localStorage);
  useEffect(()=>{
    if(isLoading===false  && localStorageRedux!== undefined)
    {
        const necessaryBoolean = (localStorageRedux.necessary === 'true');
        const marketingBoolean = (localStorageRedux.marketing === 'true');
        const performanceBoolean = (localStorageRedux.performance === 'true');
        document.getElementById('necessary').checked = necessaryBoolean;
        document.getElementById('marketing').checked = marketingBoolean;
        document.getElementById('performance').checked = performanceBoolean;
    }
  },[isLoading,localStorageRedux])

  const saveSelection = (e) => {
    // Get All Checkboxes of CookieBanner
    const cbNecessary = document.getElementById('necessary').checked;
    const cbMarketing = document.getElementById('marketing').checked;
    const cbPerformance = document.getElementById('performance').checked;
    const cookieData = {
      "necessary": `${cbNecessary}`,
      "marketing":`${cbMarketing}`,
      "performance":`${cbPerformance}`,
      "accepted":"true",
      "acceptedDateTime":`${new Date()}`,
      "savedViaButtonAction":`${e.target.getAttribute('data-c-action')}`,      
    }
    localStorage.setItem('cookieBannerData', JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData))
  
  }
  const saveSelectAll = (e) => {
    // Get All Checkboxes of CookieBanner
    const cbNecessary = true;
    const cbMarketing = true;
    const cbPerformance = true;
    const cookieData = {
      "necessary": `${cbNecessary}`,
      "marketing":`${cbMarketing}`,
      "performance":`${cbPerformance}`,
      "accepted":"true",
      "acceptedDateTime":`${new Date()}`,
      "savedViaButtonAction":`${e.target.getAttribute('data-c-action')}`,      
    }
    localStorage.setItem('cookieBannerData', JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData))
  
  }


// Cookie Banner START
  // Check if the user already agreed to the GDPCR - Cookie Banner
  useEffect(() => {
    if (typeof window !== "undefined") {
      const cookieBannerDataFromLocalStorage = localStorage.getItem(
        "cookieBannerData"
      )
        ? JSON.parse(localStorage.getItem("cookieBannerData"))
        : undefined;

      if (cookieBannerDataFromLocalStorage?.accepted === "true") {
        setShowCookieBanner(false);
      } else {
        setShowCookieBanner(true);
      }
    }
  }, []);

  const selectAll = (e) => {
    const cookieData = {
      necessary: "true",
      marketing: "true",
      performance: "true",
      accepted: "true",
      acceptedDateTime: `${new Date()}`,
      savedViaButtonAction: `${e.target.getAttribute("data-c-action")}`,
    };
    localStorage.setItem("cookieBannerData", JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData));
    setShowCookieBanner(false);
  };
  const saveSelection2 = (e) => {
    // Get All Checkboxes of CookieBanner
    const cbNecessary = document.getElementById("necessary").checked;
    const cbMarketing = document.getElementById("marketing").checked;
    const cbPerformance = document.getElementById("performance").checked;
    const cookieData = {
      necessary: `${cbNecessary}`,
      marketing: `${cbMarketing}`,
      performance: `${cbPerformance}`,
      accepted: "true",
      acceptedDateTime: `${new Date()}`,
      savedViaButtonAction: `${e.target.getAttribute("data-c-action")}`,
    };
    localStorage.setItem("cookieBannerData", JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData));
    setShowCookieBanner(false);
  };
  // Cookie Banner END

  if (isLoading===true) return null;

  return (
    <React.Fragment>       
    <div className="{styles.container}">
      <Head>
        <title>{t('meta_tag_dataprotection_page_title')}</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header/>
        <Container className="pt-0" fluid>
        <Row className='webpageTitle' style={{
          backgroundColor:variables.initial_standardHeaderBanner_backgroundColor,
          color:variables.initial_standardHeaderBanner_fontColor,
          }}>
          <Col sm={2}></Col>
          <Col sm={8}><h2>{t('link_dataprotection')}</h2></Col>
        </Row> 
          </Container>
          <Container className="pt-4 pb-5">                
          <Row>
            <Col sm={2}>
            </Col>
            <Col sm={8}>
              <ReactMarkdown 
              components={{ a: LinkRenderer}}
              remarkPlugins={[remarkGfm]}>
                {dataProtectionData.description}
              </ReactMarkdown>
            </Col>
          </Row>
          {/* <Row> */}
          <EmbeddedCookieBanner
            title={ t("cookie_banner_title") }
            subtitle={ t("cookie_banner_subtitle") }
            description={ t("cookie_banner_description") }
            text_save_selection={ t("cookie_banner_text_save_selection") }
            text_accept_all={ t("cookie_banner_text_accept_all") }
            text_checkbox_option1={ t("cookie_banner_text_checkbox_option1") }
            text_checkbox_option2={ t("cookie_banner_text_checkbox_option2") }
            text_checkbox_option3={ t("cookie_banner_text_checkbox_option3") }
            gdpr_link={ t("cookie_banner_gdpr_link") }
            gdpr_link_text={ t("cookie_banner_gdpr_link_text") }
            imprint_link={ t("cookie_banner_imprint_link_text") }
            imprint_link_text={ t("cookie_banner_imprint_link_text") }
            display={true}
            handleAcceptAllClick={saveSelectAll}
            handleSaveSelectionClick={saveSelection}            
          ></EmbeddedCookieBanner>
          {/* </Row> */}
        </Container>
        <BackToTopButton
      backgroundColor={variables.initial_backToTop_backgroundColor}
      borderColor='white'
      borderWidth='2px'
      width='40px'
      height='40px'
      iconColor='white'
      iconType={1}
      iconMarginTop='-10px'/>
      <Footer />

      <CookieBanner
        title={t("cookie_banner_title")}
        subtitle={t("cookie_banner_subtitle")}
        description={t("cookie_banner_description")}
        text_save_selection={t("cookie_banner_text_save_selection")}
        text_accept_all={t("cookie_banner_text_accept_all")}
        text_checkbox_option1={t("cookie_banner_text_checkbox_option1")}
        text_checkbox_option2={t("cookie_banner_text_checkbox_option2")}
        text_checkbox_option3={t("cookie_banner_text_checkbox_option3")}
        gdpr_link={t("cookie_banner_gdpr_link")}
        gdpr_link_text={t("cookie_banner_gdpr_link_text")}
        imprint_link={t("cookie_banner_imprint_link")}
        imprint_link_text={t("cookie_banner_imprint_link_text")}
        display={showCookieBanner}
        handleAcceptAllClick={selectAll}
        handleSaveSelectionClick={saveSelection2}
      ></CookieBanner>

    </div>
    
    </React.Fragment>
  )
}